<template>
    <section class="rodape" id="contato">
        
        <div class="container">

            <div class="row">

                <div class="col-12 col-md-3">

                    <h3>Contato</h3>

                    <div class="contato_item">
                        <div class="icon pin"></div>
                        <span>
                            Balneário Camboriú - SC
                        </span>
                    </div>

                    <div class="contato_item">
                        <div class="icon mail"></div>
                        <span>
                            <a href="mailto:deputado@carloshumbertosc.com.br">deputado@carloshumbertosc.com.br</a>
                        </span>
                    </div>

                    <div class="contato_item">
                        <div class="icon whats"></div>
                        <span>
                            +55 (48) 9 8874-2676
                        </span>
                    </div>

                </div>
                <div class="col-12 col-md-3">
                    
                    <h3>Informações</h3>

                    <ul id="menu">

                        <li>
                            <router-link :to="{ name: 'home' }">Home</router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'home', hash : '#sobre' }">Sobre</router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'home', hash : '#acoes' }">Ações</router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'home', hash : '#noticias' }">Notícias</router-link>
                        </li>
                        
                    </ul>
                </div>
                <div class="col-12 col-md-3">
                    <h3>Instagram</h3>
                    <ul id="insta">
                        <li v-for="(foto, fotoIndex) in instagram" :key="fotoIndex">
                            <a href="#">
                                <div :style="{ 'background-image': 'url(' + foto.img + ')' }" class="foto"></div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="col-12 col-md-3">
                    <h3>Entre em Contato</h3>

                    <form>
                        <input type="text" name="email" placeholder="Digite seu e-mail" />
                        <button type="submit"><img src="/images/icon-seta.png" /></button>
                    </form>

                    <h3 style="padding-bottom: 10px">Redes Sociais</h3>

                    <ul id="social">
                        <li><a href="https://www.facebook.com/carloshumbertobc" target="_blank"><div class="icon" :style="{ 'background-image' : 'url(/images/icon-rodape-facebook.png)' }" /></a></li>
                        <li><a href="https://www.instagram.com/carloshumbertobc/" target="_blank"><div class="icon" :style="{ 'background-image' : 'url(/images/icon-rodape-insta.png)' }" /></a></li>
<!--                        <li><a href="#"><div class="icon" :style="{ 'background-image' : 'url(/images/icon-rodape-pinterest.png)' }" /></a></li>
                        <li><a href="#"><div class="icon" :style="{ 'background-image' : 'url(/images/icon-rodape-google.png)' }" /></a></li>-->
                        <li><a href="https://twitter.com/CarlosH_SC" target="_blank"><div class="icon" :style="{ 'background-image' : 'url(/images/icon-rodape-twitter.png)' }" /></a></li>
                    </ul>
                </div>

            </div>

            <div class="row">
                <div class="col-12">
                    <span class="copy">
                        © Copyright 2023 - Todos os direitos reservados.<br>
                        Desenvolvido por <a href="http://www.produtorarocket.com" target="_blank">Produtora Rocket</a>.
                    </span>
                </div>
            </div>

        </div>
        
    </section>
</template>

<script>
export default {
    
    data() {
        return {
            instagram: [
                {
                    img: 'images/insta/insta1.jpg',
                    url: '#'
                },
                {
                    img: 'images/insta/insta2.jpg',
                    url: '#'
                },
                {
                    img: 'images/insta/insta3.jpg',
                    url: '#'
                },
                {
                    img: 'images/insta/insta4.jpg',
                    url: '#'
                },
                {
                    img: 'images/insta/insta5.jpg',
                    url: '#'
                },
                {
                    img: 'images/insta/insta6.jpg',
                    url: '#'
                }
            ]
        }
    }
}
</script>